import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import SafeImage from './SafeImage';
import './GalleryModal.css';

function GalleryModal({ isOpen, onClose, images, currentIndex, onNavigate }) {
  if (!isOpen || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];
  const hasPrevious = currentIndex > 0;
  const hasNext = currentIndex < images.length - 1;

  const handlePrevious = () => {
    if (hasPrevious) {
      onNavigate(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (hasNext) {
      onNavigate(currentIndex + 1);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft') handlePrevious();
    if (e.key === 'ArrowRight') handleNext();
    if (e.key === 'Escape') onClose();
  };

  return (
    <div 
      className="gallery-modal-overlay" 
      onClick={onClose}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <button className="gallery-modal-close" onClick={onClose} aria-label="Close">
        <X size={32} />
      </button>

      <div className="gallery-modal-content" onClick={(e) => e.stopPropagation()}>
        <SafeImage
          src={currentImage.imageUrl}
          alt={currentImage.alt || `Gallery image ${currentIndex + 1}`}
          className="gallery-modal-image"
          loading="eager"
        />

        {hasPrevious && (
          <button 
            className="gallery-modal-nav gallery-modal-prev" 
            onClick={handlePrevious}
            aria-label="Previous image"
          >
            <ChevronLeft size={48} />
          </button>
        )}

        {hasNext && (
          <button 
            className="gallery-modal-nav gallery-modal-next" 
            onClick={handleNext}
            aria-label="Next image"
          >
            <ChevronRight size={48} />
          </button>
        )}

        <div className="gallery-modal-counter">
          {currentIndex + 1} / {images.length}
        </div>
      </div>
    </div>
  );
}

export default GalleryModal;
